import { useDispatch } from 'react-redux';

import { requestSendResetPasswordEmail } from '../../../api/login/login.actions';

import RecoverPassword from '../../../components/screens/auth/recover-password/RecoverPassword';

const RecoverPasswordContainer = () => {
  const dispatch = useDispatch();

  const submitEmail = (email, successFunction) => {
    dispatch(requestSendResetPasswordEmail({ email, onSuccess: () => successFunction(true) }));
  };

  return <RecoverPassword submitEmail={submitEmail} />;
};

export default RecoverPasswordContainer;
